<template>
  <div id="glossary">
    <h1>ワルツ(Waltz)について</h1>

    ここではワルツ(Waltz)を紹介します。SetDancePalの中の人は実はワルツが一番好きです。誤りなどありましたらご指摘ください。オススメのワルツも募集中です。
    <br />
    <br />
    セットダンスと同じく、ジェンツは左足から、レディーは右足から動きます。ワルツには特定の型があるものや、型のない自由に動くものもあります。
    <br />
    <br />

    <md-card md-with-hover>
      <md-card-header>
        <div class="md-title">St.Bernard Waltz</div>
        <div class="md-subhead">セント・バーナード・ワルツ</div>
        <!-- <div class="md-subhead">URL：<a href="https://www.youtube.com/watch?v=U5SML9l59ns" target=_blank>https://www.youtube.com/watch?v=U5SML9l59ns</a></div> -->
      </md-card-header>
      <md-card-content>
        <iframe width="560" height="315" src="https://www.youtube.com/embed/U5SML9l59ns?start=9" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <br/>
        <br/>
        <md-tabs md-fixed>
          <md-tab id="movies" md-label="Gents">
            <ol style="text-align: left;">
              <li>左に三歩進んで足踏み、またはUp/Dwon</li>
              <li>右に二歩進んで、後ろに2歩下がる</li>
              <li>前に二歩進んで、左手でレディーを時計回りにターンさせる</li>
              <li>Waltz holdになって軽く動きながらHomeを2回する</li>
            </ol>
          </md-tab>

          <md-tab id="music" md-label="Ladies">
            <ol style="text-align: left;">
              <li>右に三歩進んで足踏み、またはUp/Dwon</li>
              <li>左に二歩進んで、前に2歩進む</li>
              <li>後ろに二歩下がって、時計回りにターンする</li>
              <li>Waltz holdになって軽く動きながらHomeを2回する</li>
            </ol>
          </md-tab>
        </md-tabs>
      </md-card-content>
    </md-card>

    <md-card md-with-hover>
      <md-card-header>
        <div class="md-title">Waltz of the bells</div>
        <div class="md-subhead">セント・オブ・ザ・ベルズ</div>
        <!-- <div class="md-subhead">URL：<a href="https://www.youtube.com/watch?v=kcYO_eLrFuQ" target=_blank>https://www.youtube.com/watch?v=kcYO_eLrFuQ</a></div> -->
      </md-card-header>
      <md-card-content>
        <iframe width="560" height="315" src="https://www.youtube.com/embed/kcYO_eLrFuQ?start=9" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <br/>
        <br/>
        <md-tabs md-fixed>
          <md-tab id="movies" md-label="Gents">
            <ol style="text-align: left;">
              <li>体を左、右、左、右、の順に開く。体を開く方向とは逆側の足を上げる</li>
              <li>反時計回りにターンしてパートナーと向き合い、両手をつないで左に二歩進む</li>
              <li>体を右、左、右、左、の順に開く。体を開く方向とは逆側の足を上げる</li>
              <li>時計回りにターンしてパートナーと向き合い、両手をつないで右に二歩進む</li>
              <li>左に二歩進んで、左手でレディーを時計回りにターンさせる</li>
              <li>右に二歩進んで、右手でレディーを反時計回りにターンさせる</li>
              <li>両手をつないだまま、閉じて、開いて、閉じて、開いてを繰り返す</li>
              <li>Waltz holdになって軽く動きながらHomeを2回する</li>
            </ol>
          </md-tab>

          <md-tab id="music" md-label="Ladies">
            <ol style="text-align: left;">
              <li>体を右、左、右、左、の順に開く。体を開く方向とは逆側の足を上げる</li>
              <li>時計回りにターンしてパートナーと向き合い、両手をつないで右に二歩進む</li>
              <li>体を左、右、左、右、の順に開く。体を開く方向とは逆側の足を上げる</li>
              <li>反時計回りにターンしてパートナーと向き合い、両手をつないで左に二歩進む</li>
              <li>右に二歩進んで、反時計回りにターンする</li>
              <li>左に二歩進んで、時計回りにターンする</li>
              <li>両手をつないだまま、閉じて、開いて、閉じて、開いてを繰り返す</li>
              <li>Waltz holdになって軽く動きながらHomeを2回する</li>
            </ol>
          </md-tab>
        </md-tabs>
      </md-card-content>
    </md-card>

    <md-divider></md-divider>

    <span class="md-caption">copyright © 2017-{{ new Date().getFullYear() }} Hiroshi Jo</span>

  </div>
</template>

<script>
// import db from '../db'

export default {
  name: 'set',
  data () {
    return {
      error: null
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

h2 {
  margin-top: 48px;
}

a {
  color: #42b983;
}

.md-divider {
  margin: 32px 0 8px 0;
}
</style>



// WEBPACK FOOTER //
// Waltz.vue?5c2e6319